<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        캠페인 등록
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          캠페인 등록 후, 상품(지면) 선택 및 세부 설정이 가능합니다!
        </span>
      </h2>
      <ul class="progress-step mb-10">
        <li class="active">
          <p class="state">
            <span class="num">1</span>
            <span class="check">
              <v-icon>mdi-check</v-icon>
            </span>
          </p>
          <p class="text">캠페인 정보</p>
        </li>
        <li class="">
          <p class="state">
            <span class="num">2</span>
          </p>
          <p class="text">캠페인 상품등록</p>
        </li>
      </ul>

      <v-form ref="form" v-model="valid">
        <!-- campaignName -->
        <h3 class="title-type-3">
          캠페인명
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8">
          <v-text-field
            class="input-custom-2"
            height="40px"
            v-model="campaignName"
            solo
            required
            :rules="camapignNameRules"
            placeholder="캠페인명을 입력해주세요."
          ></v-text-field>
          <p class="form-coment-1 mt-n2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            캠페인 시작 후 캠페인명은 변경이 불가합니다.
          </p>
        </div>
        <!--// campaignName -->
        <!-- campaign date range -->
        <h3 class="title-type-3">
          캠페인 기간
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8 d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="dateRange"
              :date-format="dateFormat"
              :locale-data="localeData"
              :ranges="false"
              :time-picker="true"
              :time-picker-seconds="true"
              :time-picker-increment="1"
              opens="right"
            ></date-range-picker>
          </div>
        </div>
        <!-- //campaign date range -->

        <div class="form-wrap">
          <!-- advertiser select -->
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              광고주
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <div class="search-1">
                <span class="readinput" style="width: 350px">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    min-width="300px"
                    v-model="advertiserName"
                    hide-details
                    solo
                    readonly
                    @click.stop="openAdvertiserPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.stop="openAdvertiserPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="adviertierCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <!-- advertiser select -->
          <!-- agency select -->
          <div class="form-group mb-8">
            <h3 class="title-type-3">대행사</h3>
            <div class="d-flex white rounded pa-6">
              <div class="search-1">
                <span class="readinput" style="width: 350px">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    min-width="300px"
                    v-model="agencyName"
                    hide-details
                    solo
                    readonly
                    @click.prevent="openAgencyPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.prevent="openAgencyPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="agencyCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <!-- agency select -->
        </div>
        <!-- 노출관리 -->
        <h3 class="title-type-3">
          노출관리
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8">
          <v-radio-group v-model="isValid" class="mt-0" row>
            <v-radio
              label="ON"
              value="Y"
              color="#fecd00"
              class="radio-type-1"
            ></v-radio>
            <v-radio
              label="OFF"
              value="N"
              color="#fecd00"
              class="radio-type-1 ml-10"
            ></v-radio>
          </v-radio-group>
        </div>
        <!--// 노출관리 -->

        <!--btn-group-->
        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="!valid || !this.dateRange || !this.advertiserId"
            @click.prevent="registerCampaign"
          >
            저장
          </v-btn>
        </div>
        <!--//btn-group-->
      </v-form>
      <SystemAlert v-model="showSystemAlert">
        <div slot="noti-text" v-html="logResult"></div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="closePopup"
          >
            확인
          </v-btn>
        </div>
      </SystemAlert>

      <div v-if="this.searchAdveriser">
        <SearchOnlyAdvertiserModal
          v-model="searchAdveriser"
          @select:advertiser="selectAdvertiser"
        />
      </div>
      <div v-if="this.searchAgency">
        <SearchAgencyModal
          v-model="searchAgency"
          @select:advertiser="selectAgency"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import DateRangePicker from 'vue2-daterange-picker';
import { toISOFormattedDate } from '@/utils/validation';
import { advertiserList } from '@/api/advertiser';
import { createCampaign } from '@/api/campaign';
import SystemAlert from '~@/modal/SystemAlert.vue';
import SearchOnlyAdvertiserModal from '~@/modal/SearchOnlyAdvertiserModal';
import SearchAgencyModal from '~@/modal/SearchAgencyModal';

import moment from 'moment';

let defaultStartAt = new Date();
defaultStartAt.setHours(0, 0, 0, 0);
defaultStartAt = moment(defaultStartAt);

let defaultEndAt = new Date();
defaultEndAt.setHours(23, 59, 0, 0);
defaultEndAt = moment(defaultEndAt).add(1, 'months');

export default {
  components: {
    SearchOnlyAdvertiserModal,
    SearchAgencyModal,
    DateRangePicker,
    SystemAlert,
  },
  data: () => ({
    valid: false,
    campaignName: '',
    camapignNameRules: [
      v => !!v || '캠페인명을 입력해주세요.',
      v =>
        (v && v.length <= 20) ||
        '20자 이내의 한글/영문/숫자만 입력 가능합니다.',
      v =>
        (v && /[a-z|A-Z|0-9|ㄱ-ㅎ|가-힣]$/.test(v)) ||
        '20자 이내의 한글/영문/숫자만 입력 가능합니다.',
    ],
    dateRange: {
      startDate: defaultStartAt,
      endDate: defaultEndAt,
    },
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    advertiserNames: [],
    searchSelAdvertiser: '',
    advertiserMap: {},

    advertiserName: '',
    advertiserId: '',

    agencyNames: [],
    searchSelAgency: '',
    agencyMap: {},

    agencyName: '',
    agencyId: '',

    isValid: 'N',

    showSystemAlert: false,
    logResult: '',
    resultType: '',
    campaignId: '',

    searchAdveriser: false,
    searchAgency: false,
  }),
  computed: {},
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < defaultStartAt;
      }
      return classes;
    },
    async getAdvertiserList() {
      try {
        const { data } = await advertiserList();
        bus.$emit('end:spinner');
        const list = data.list;
        const advertiserMap = {};
        const advertiserNames = [];
        const agencyMap = {};
        const agencyNames = [];
        (list || []).forEach(item => {
          if (item.type === 'advertiser' || item.type === 'internal') {
            advertiserMap[item.name] = item;
            advertiserNames.push(item.name);
          } else if (item.type === 'agency') {
            agencyMap[item.name] = item;
            agencyNames.push(item.name);
          }
          this.advertiserMap = advertiserMap;
          this.advertiserNames = advertiserNames;

          this.agencyMap = agencyMap;
          this.agencyNames = agencyNames;
        });
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    async registerCampaign() {
      bus.$emit('start:spinner');
      let startDate = toISOFormattedDate(this.dateRange.startDate);
      let endDate = toISOFormattedDate(this.dateRange.endDate);

      try {
        const campaignData = {
          name: this.campaignName.replace(/\s/g, ''),
          start_at: startDate,
          end_at: endDate,
          advertiser: { id: this.advertiserId },
          agency: { id: this.agencyId },
          is_valid: this.isValid,
        };

        const { data } = await createCampaign(campaignData);

        this.resultType = data.result;
        this.resultType = data.result;
        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.showSystemAlert = true;
          this.logResult = '신규 캠페인이 등록되었습니다.';
          this.campaignId = data.value;
        }
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
        const { data } = error.response;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 캠페인명이 있습니다.';
        } else {
          this.showSystemAlert = true;
          this.logResult = '등록 중 에러가 발생했습니다. 재시도 부탁드립니다.';
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      const id = this.campaignId;
      if (type === 'success') {
        this.$router
          .push({ path: `/campaign/${id}/inventories_list` })
          .catch(() => {});
      }
      this.showSystemAlert = false;
    },
    cancel() {
      this.$refs.form.reset();
      this.$router.push({ name: 'campaign' }).catch(() => {});
    },
    openAdvertiserPopup() {
      this.searchAdveriser = true;
    },
    openAgencyPopup() {
      this.searchAgency = true;
    },
    selectAdvertiser(data) {
      this.advertiserName = data.name;
      this.advertiserId = data.id;
    },
    selectAgency(data) {
      this.agencyName = data.name;
      this.agencyId = data.id;
    },
    adviertierCancel() {
      this.advertiserName = '';
      this.advertiserId = '';
    },
    agencyCancel() {
      this.agencyName = '';
      this.agencyId = '';
    },
  },
  created() {
    //bus.$emit('start:spinner');
    //this.getAdvertiserList();
  },
};
</script>

<style lang="scss" scoped></style>
